module.exports = __webpack_public_path__ + "img/checkmark.d962bc43.svg";